import * as React from 'react';
import { Button, FormGroup, Input, Label } from 'reactstrap';
import { Blank, mergeClasses } from '../constants';
import './ChoiceSelector.scss';
import { IconProps } from './Icons';

export type Choice = {
  icon?: React.ComponentType<IconProps>;
  label: string;
  value: string;
};

export type ChoiceProps = Choice & {
  name?: string;
  currentValue: string | null;
  disabled: boolean;
  onClick: (arg0: string) => void;
};

export class ChoiceButton extends React.Component<ChoiceProps> {
  handleClick = () => {
    const { onClick, value } = this.props;
    onClick(value);
  };

  render() {
    const {
      currentValue,
      disabled,
      icon: IconWidget = Blank,
      label,
      value,
      name,
    } = this.props;
    return (
      <Button
        name={name}
        color="primary"
        className="choice-button"
        active={value === currentValue}
        onClick={this.handleClick}
        disabled={disabled}
      >
        <IconWidget />
        <br />
        {label}
      </Button>
    );
  }
}

export class ChoiceRadio extends React.Component<ChoiceProps> {
  handleClick = () => {
    const { onClick, value } = this.props;
    onClick(value);
  };

  render() {
    const { currentValue, disabled, label, value, name } = this.props;
    return (
      <FormGroup check>
        <Label check>
          <Input
            name={name}
            type="radio"
            onChange={this.handleClick}
            checked={value === currentValue}
            disabled={disabled}
          />
          {label}
        </Label>
      </FormGroup>
    );
  }
}

type Props = {
  choices: Array<Choice>;
  className?: string;
  disabledValues?: Array<string>;
  onChange: (arg0: string) => void;
  currentValue?: string | null;
  asRadioButtons: boolean;
};

export default class ChoiceSelector extends React.Component<Props> {
  render() {
    const {
      choices,
      className,
      disabledValues = [],
      onChange,
      asRadioButtons,
      currentValue = null,
    } = this.props;
    const Widget = asRadioButtons ? ChoiceRadio : ChoiceButton;
    return (
      <div
        role="group"
        className={mergeClasses(['choice-selector', className])}
      >
        {choices.map((choice) => (
          <Widget
            name={choice.value}
            currentValue={currentValue}
            value={choice.value}
            disabled={disabledValues.includes(choice.value)}
            icon={choice.icon}
            key={choice.value}
            label={choice.label}
            onClick={onChange}
          />
        ))}
      </div>
    );
  }
}
